/**
 * @see helpers/global
 */
import axios from 'axios';
import { API_URL, getApiHeaders } from "./api.js"




// POST Depot
const fetchDepotCases = postData => (
    axios.post(`${API_URL}/customer/depot/cases`, postData, getApiHeaders())
)

// GET Depot
const fetchDepotDetails = depotCaseId => axios.get(
    `${API_URL}/customer/depot/details/` + depotCaseId, getApiHeaders()
);

// DEPOT PUT
const actionProductDepotIn = postData => (
    axios.put(`${API_URL}/customer/articles/product/request/depot-in`, postData, getApiHeaders())
);
const processDepotRequest = formData => {
    return axios.put(`${API_URL}/customer/depot/request`, formData, getApiHeaders())
}
const actionProductDepotOut = postData => (
    axios.put(`${API_URL}/customer/depot/request/depot-out`, postData, getApiHeaders())
);

export {
    processDepotRequest,
    actionProductDepotIn,
    actionProductDepotOut,
    fetchDepotCases,
    fetchDepotDetails,
}